// import apiService from "../../services/apiService";
import ImageInput from "../../secured/views/ImageInput";
import userManagementService from "../../../services/userManagementService";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
export default {
  name: "user-profile",
  components: {
    ImageInput: ImageInput,
    pageheader: pageheader
  },
  props: [],
  data() {
    return {
      valid: true,
      loading: false,
      input: {},
      authRole: ["Admin", "Manager"],
      result: [],
      showAvatarPicker: false,
      isEditing: false,
      avatar: {
        imageURL: null
      },
      saving: false,
      saved: false,
      isUpload: false,
      isAvatar: false,
      isProfile: false
    };
  },
  watch: {
    avatar: {
      handler: function(val) {
        if (val.isUpload) {
          this.isAvatar = true;
        }
        this.saved = false;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["roles"])
  },
  mounted() {
    this.input = utils.getInputContent("profile", this.roles);
    this.getProfileById();
  },
  methods: {
    getProfileById() {
      this.isProfile = true;
      userManagementService.getUsersId(
        this.$store.state.user.id,
        this,
        response => {
          if (response) {
            this.isProfile = false;
            this.result = response.user;
            if (this.result.profilePicture) {
              this.avatar.imageURL = this.result.profilePicture;
            }
            //   if (this.user.registeredUsing == "Standard") {
            //     this.isProvider = true;
            //   } else if (
            //     this.user.registeredUsing == "" ||
            //     this.user.registeredUsing == "Microsoft"
            //   ) {
            //     this.isProvider = false;
            //     this.isEditing = false;
            //   }
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    cancelUpdate(isedit) {
      this.isEditing = !isedit;
    },
    uploadImage() {
      this.saving = true;
      this.isUpload = true;
      let payload = {
        detail: this.avatar.imageString
      };
      userManagementService.updateProfileImage(
        this.$store.state.user.id,
        payload,
        this,
        response => {
          if (response.isSuccess) {
            this.$store.commit("setPicture", this.avatar.imageString);
            this.$toast.success(response.systemMessage);
          }
        },
        error => {
          this.$toast.error("Unable to upload profile image" + error);
        }
      );

      setTimeout(() => this.savedAvatar(), 1000);
    },
    savedAvatar() {
      this.isAvatar = false;
      this.saving = false;
      this.saved = true;
    },
    cancelUpload() {
      if (this.result.image) {
        this.avatar.imageURL = this.result.image;
      }
      setTimeout(() => this.savedAvatar(), 1000);
    },
    reset() {
      this.$refs.form.reset();
    },
    profileUpdate() {
      if (this.$refs.form.validate()) {
        console.log(this.result);
        this.loading = true;
        let payload = {
          id: this.$store.state.user.id,
          firstName: this.result.firstName,
          lastName: this.result.lastName,
          phoneNumber: this.result.phoneNumber ? this.result.phoneNumber : "",
          eventIds:
            this.result.eventIds != [] || this.result.eventIds != null
              ? this.result.eventIds
              : "",
          role: this.result.role
        };
        userManagementService.updateUsersId(
          this,
          this.result.userId,
          payload,
          response => {
            if (response) {
              this.loading = false;
              setTimeout(() => {
                this.$toast.success("Updated Succesfully"), 2000;
              });
              this.cancelUpdate(true);
            }
          },
          error => {
            this.loading = false;

            console.log(error);
          }
        );
        //   try {
        //     let apiResponse = await apiService.updateUser(this.userId, payload);
        //     if (apiResponse) {
        //       this.loading = false;
        //       let name = this.result.firstName + " " + this.result.lastName;
        //       this.$store.commit("SET_NAME", name);
        //       this.$store.commit("SET_PHONENUMBER", this.result.phoneNumber);

        //       setTimeout(() => {
        //         this.$toast.success("Updated Succesfully"), 2000;
        //       });
        //       this.cancelUpdate(true);
        //     }
        //   } catch (err) {
        //     this.loading = false;
        //     this.$toast.error("Oops!!! something went wrong" + err);
        //     this.getProfileById();
        //   }
      }
    }
  }
};
